import React from "react"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
} from "chart.js"
import { Bar } from "react-chartjs-2"
import annotationPlugin from "chartjs-plugin-annotation"

export interface RegionData {
  loc: string
  substitutionRate: number
  afterSubRate: number
}

interface BarChartProps {
  data: {
    정읍Data: any
    대전Data: any
    보령Data: any
    여수Data: any
  }
  height?: string
  width?: string
  annotations?: number
}

// Chart.js 플러그인 등록
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  annotationPlugin
)

const Page3Barchart1: React.FC<BarChartProps> = ({
  data: { 정읍Data, 대전Data, 보령Data, 여수Data },
  height = "300px",
  width = "500px",
  annotations,
}) => {
  const labels = ["정읍", "대전", "보령", "여수"]

  const chartData = {
    labels,
    datasets: [
      {
        label: "거래 전",
        data: [
          Number(정읍Data?.substitutionRate?.toFixed(0))?.toLocaleString() || 0,
          Number(대전Data?.substitutionRate?.toFixed(0))?.toLocaleString() || 0,
          Number(보령Data?.substitutionRate?.toFixed(0))?.toLocaleString() || 0,
          Number(여수Data?.substitutionRate?.toFixed(0))?.toLocaleString() || 0,
        ],
        backgroundColor: "#BFBFBF",
        borderRadius: 5,
      },
      {
        label: "거래 후",
        data: [
          Number(정읍Data?.afterSubRate?.toFixed(0))?.toLocaleString() || 0,
          Number(대전Data?.afterSubRate?.toFixed(0))?.toLocaleString() || 0,
          Number(보령Data?.afterSubRate?.toFixed(0))?.toLocaleString() || 0,
          Number(여수Data?.afterSubRate?.toFixed(0))?.toLocaleString() || 0,
        ],
        backgroundColor: "#2669DE",
        borderRadius: 5,
      },
    ],
  }

  const options: import("chart.js").ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {},
      y: {
        beginAtZero: true,
        max: 100,
        title: {
          display: false,
        },
        ticks: {
          callback: (value) => `${value}%`, // y축 값에 % 추가
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      tooltip: {
        enabled: true, // 툴팁 활성화
        callbacks: {
          label: function (tooltipItem) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.raw}%`
          },
        },
      },
      annotation: {
        annotations: {
          line1: {
            type: "line",
            yMin: annotations, // 수평선의 Y축 값
            yMax: annotations,
            borderColor: "#B89EFA",
            borderWidth: 3,
            borderDash: [5, 5],
            // label: {
            //   content: `${annotations}%`, // 레이블 텍스트
            //   display: true, // 레이블 표시 여부
            //   position: "end", // 레이블 위치
            //   backgroundColor: "rgba(255, 255, 255, 0.8)", // 레이블 배경색
            //   color: "#B89EFA", // 레이블 텍스트 색상
            // },
          },
        },
      },
    },
  }

  return (
    <div style={{ height, width }}>
      <Bar data={chartData} options={options} />
    </div>
  )
}

export default Page3Barchart1
